export default __webpack_public_path__ + "static/media/g.9a9b04cd.png";